import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../i18n'

Vue.use(Vuex)
export default new Vuex.Store({
  //plugins: [vuexLocalStorage.plugin],
  state: {
    "loginModal": {
      "state":"hidden"
    },
    "auth": {
      "tokenObject" : null,
    },
    "system" : {
      "parameters" : null
    },
    "userPreferences" : null,
    "infopoints": {
      "infopointList":{
         "ipEntries":[]
      }
    },
    "locale": null,
    "path" : null,
    "view" : null,
    "views" : new Map(),
    "pathInformationChanged": null
  },
  mutations: {
    /*
     * Tallenna käyttöoikeudet ja asetukset
     */
    login(state, userData){
      // auth token
      state.auth.tokenObject = userData.authToken;
      sessionStorage.setItem('AUTH_TOKEN', userData.authToken);

      // user preferences
      state.userPreferences = userData.userPreferences;
      sessionStorage.setItem('USER_PREFS',JSON.stringify(userData.userPreferences));

      // user locale
      state.locale = userData.userPreferences.userLang;
      i18n.locale = state.locale;
      sessionStorage.setItem('USER_LOCALE', state.locale);
      localStorage.setItem('TRAVELLER_USER_LOCALE', state.locale);

      // current path & view
      state.path = null;
      state.view = null;

      state.loginModal.state = "hidden";

    },

    logout(state){
      // auth token
      state.auth.tokenObject = null;
      sessionStorage.removeItem('AUTH_TOKEN');

      // user preferences
      state.userPreferences = null;
      sessionStorage.removeItem('USER_PREFS');

      // user locale
      state.locale = null;
      sessionStorage.removeItem('USER_LOCALE');

      // current path & view
      state.path = null;
      sessionStorage.removeItem('CURRENT_PATH');

      state.view = null;
      sessionStorage.removeItem('CURRENT_VIEW');

      state.auth.vtravellerToken = null;
      sessionStorage.removeItem('VTRAVELLER_TOKEN');
    },

    reloadLoginData(state) {
      state.auth.tokenObject = sessionStorage.getItem('AUTH_TOKEN');
      state.userPreferences = JSON.parse(sessionStorage.getItem('USER_PREFS'));
      state.locale = sessionStorage.getItem('USER_LOCALE');
      i18n.locale = state.locale;

      state.path = sessionStorage.getItem('CURRENT_PATH');
      state.view = sessionStorage.getItem('CURRENT_VIEW');
    },

    setPath(state, path){
      state.path = path;
      sessionStorage.setItem('CURRENT_PATH', state.path);

      state.pathInformationChanged = Date.now();
    },

    setView(state, view){
      state.view = view;
      sessionStorage.setItem('CURRENT_VIEW', state.view);
    },

    addViewInfo(state, view) {
      state.views.set(view.path, view);

      state.pathInformationChanged = Date.now();
    },

    setLoginModalVisible(state) {
      state.loginModal.state = "visible";
    },
  
    storeLoginData(state, loginData) {
      if(loginData.authToken !== undefined) {
        state.auth.tokenObject = loginData.authToken;
        if (typeof(sessionStorage) !== "undefined") {
          sessionStorage.setItem('AUTH_TOKEN',loginData.authToken);
        }
      }
      if(loginData.userPreferences !== undefined) {
        state.userPreferences = loginData.userPreferences;
        if (typeof(sessionStorage) !== "undefined") {
          sessionStorage.setItem('USER_PREFS',JSON.stringify(loginData.userPreferences));
        }
      }
    },

    refreshAuthToken(state) {
      if(state.auth.tokenObject === null) {
        if (typeof(sessionStorage) !== "undefined") {
          state.auth.tokenObject = sessionStorage.getItem('AUTH_TOKEN');
          state.userPreferences = JSON.parse(sessionStorage.getItem('USER_PREFS'));
        } 
      }
    },
    
    setInfopointEntryList(state, entryList) {
      state.infopoints.infopointList.ipEntries = entryList;
    },
    setLocale(state, locale){
      state.locale = locale;
      sessionStorage.setItem('USER_LOCALE', state.locale);
    },
    setSystemParams(state, params){
      state.system.parameters = params;
    },
    setUiConfig(state, params){
      sessionStorage.setItem('UI_CONFIGURATION', JSON.stringify(params))
      state.ui_configuration = params;
    },
    storeVTravellerToken(state, data) {
        if (data.vtravellerToken !== undefined) {
            state.auth.vtravellerToken = data.vtravellerToken;
            if (typeof(sessionStorage) !== "undefined") {
                sessionStorage.setItem('VTRAVELLER_TOKEN', data.vtravellerToken);
            }
        }
    },
    refreshVTravellerToken(state) {
        if (state.auth.vtravellerToken === null) {
            if (typeof(sessionStorage) !== "undefined") {
                state.auth.vtravellerToken = sessionStorage.getItem('VTRAVELLER_TOKEN');
            } 
        }
    }
  },
  actions: {
    setLocale(context, locale){
      i18n.locale = locale;
      context.commit('setLocale', locale)
    },
    getSystemParameters(context) {
      return new Promise((resolve , reject) => {
        if(context.state.system.parameters != null) {
          resolve(context.state.system.parameters);
        }
         const vm = this;
         this._vm.$traveller_http.get('/traveller/restui/system/getSystemParameters')
           .then(function(resp) {
             if(resp.data.code !== undefined) {
               reject("error in query");
               return;
             }
             vm.listData = resp.data;
             context.commit('setSystemParams', resp.data );
             resolve(resp.data);
           })
        })
    },

    getUiConfig(context) {
      return new Promise((resolve , reject) => {
         const vm = this;
         this._vm.$traveller_http.get('/traveller/restui/configuration/uiConfiguration')
           .then(function(resp) {
             if(resp.data.code !== undefined) {
               reject("error in query");
               return;
             }
             vm.listData = resp.data;
             context.commit('setUiConfig', resp.data );
             resolve(resp.data);
           })
        })
    }
  },
  getters: {
    isAuthenticationOk: (state) => {
      if(state.auth.tokenObject === null) {
        if (typeof(sessionStorage) !== "undefined" && sessionStorage.getItem('AUTH_TOKEN') !== null) {
          return true;
        }
      }
      return state.auth.tokenObject !== null
    },
    loggedInUser: (state, getters) => {
      if(getters.isAuthenticationOk && state.userPreferences !== null) {
          return state.userPreferences.userFirstName;
      }
      return "??";
    },
    userPrivileges: (state) => {
      try {
        if(state.userPreferences.userRightList != null) {
          return state.userPreferences.userRightList;
        }
        if (typeof(sessionStorage) !== "undefined" && sessionStorage.getItem('USER_PREFS') !== null) {
          let prefs = sessionStorage.getItem('USER_PREFS');
          return prefs.userRightList;
        } else {
          return [];
        }
      }catch(err) {
        return [];
      }
    },
    userLanguage: (state) => {
      return state.userPreferences != null ? state.userPreferences.userLang : "";
    },
    currentLocale: (state) => {
      return state.locale;
    },
    systemLanguages(state) {
      return state.system?.parameters?.system_languages
    },
    uiConfiguration (state) {
      if (state.ui_configuration === undefined) {
        if (typeof(sessionStorage) !== "undefined") {
          var item = sessionStorage.getItem('UI_CONFIGURATION')
          if(item != undefined) {
            state.ui_configuration= JSON.parse(item);
          }
            
        } 
    }
      return state.ui_configuration
    },
  },

  modules: {
    user: user,
    userDataHandler: userDataHandler
  }

})

import user from './modules/user'
import userDataHandler from './system/userDataHandler'
